import styled from 'styled-components'

export const Wrapper = styled.div`
  button {
    width: auto;
    margin-right: auto;
    margin-top: 20px;
    font-size: 14px;
  }

  select {
    padding: 10px 12px;
  }
`

export const Field = styled.div`
  & > input {
    font-size: 12px;
    padding: 10px 12px;
    width: 100%;
  }

  & > label {
    font-weight: var(--font-regular);
    font-size: 12px;
    display: block;
    text-align: left;
    margin-bottom: 10px;
  }
`
